var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/previous.c58a9300.png","uri@2x": __webpack_public_path__ + "static/media/previous.9810aa9f.png","uri@3x": __webpack_public_path__ + "static/media/previous.5a480a6e.png",
    width: 51,
    height: 49
});